import React from 'react';
import { Text, View, StyleSheet, Link, Image } from '@react-pdf/renderer';
import ESLogo from '../../../../assets/images/bcc/es-logo.png';

type Props = {
  zNumber: number;
};

const styles = StyleSheet.create({
  paragraph: {
    fontSize: 14,
    color: '#000',
    textAlign: 'center',
  },
});

const NinthPage = ({ zNumber }: Props) => {
  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      wrap={false}
    >
      <Image
        style={{ width: 142, height: 142, marginBottom: 80 }}
        src={ESLogo}
      />
      <View
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: 356,
          paddingLeft: 48,
          paddingRight: 48,
          marginBottom: 80,
          borderRadius: 4,
          backgroundColor: '#F7FAFC',
        }}
      >
        <Text
          style={{
            fontFamily: 'Helvetica-Bold',
            fontSize: 20,
            marginBottom: 16,
            color: '#4E73C3',
          }}
        >
          Have your say!
        </Text>
        <Text style={{ ...styles.paragraph, marginBottom: 16 }}>
          Tell us what you want to see in these reports:
        </Text>
        <Text style={{ ...styles.paragraph, textDecoration: 'underline' }}>
          SchoolsAQMonitors@birmingham.gov.uk
        </Text>
      </View>
      <Text style={styles.paragraph}>
        This report was made possible by Zephyr #{zNumber}
      </Text>
      <View
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: 60,
        }}
      >
        <Link
          style={{ fontSize: 14, textAlign: 'center', color: '#4E73C3' }}
          src="https://www.earthsense.co.uk/"
        >
          earthsense.co.uk
        </Link>
      </View>
    </View>
  );
};

export default NinthPage;
